import commonService from "./common";

const provisioningService = {
	/* provisioning */
	submitAddSubscriber(formData) {
		let {
			iccidInfo,
			imsiInfo,
			msisdnInfo,
			subscriberNameInfo,
			hssProfileInfo,
			hlrProfileInfo,
			busyActive,
			busyNumber,
			busyProvision,
			notAvailableActive,
			notAvailableNumber,
			notAvailableProvision,
			notReachableProvision,
			notReachableNumber,
			notReachableActive,
			unconditionalActive,
			unconditionalNumber,
			unconditionalProvision,
			clip_profile_status,
			callWaiting,
			enableData,
			localData,
			mms,
			sms,
			dataPlanInfo,
			tis,
			lte,
		} = formData;
		let param = `StartQueue&action=AddSubscriber&iccid=${iccidInfo}&imsi=${imsiInfo}&msisdn=${msisdnInfo}&subscribername=${subscriberNameInfo}&hssprofile=${hssProfileInfo}&hlrprofile=${hlrProfileInfo}&cfb_hlr_status=${busyActive}&cfb_number=${busyNumber}&cfb_profile_status=${busyProvision}&cfna_hlr_status=${notAvailableActive}&cfna_number=${notAvailableNumber}&cfna_profile_status=${notAvailableProvision}&cfnr_hlr_status=${notReachableActive}&cfnr_number=${notReachableNumber}&cfnr_profile_status=${notReachableProvision}&cfu_hlr_status=${unconditionalActive}&cfu_number=${unconditionalNumber}&cfu_profile_status=${unconditionalProvision}&clip_profile_status=${clip_profile_status}&cw_profile_status=${callWaiting}&data=${enableData}&local_data_only=${localData}&mms=${mms}&sms_profile_status=${sms}&data_plan_name=${dataPlanInfo}&tis=${tis}&lte=${lte}&debug=0`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSuspendSubscriber(imsi) {
		let param = `SuspendSubscriber&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitResumeSubscriber(imsi) {
		let param = `UnsuspendSubscriber&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitTerminateSubscriber(imsi) {
		let param = `StartQueue&action=RemoveSubscriber&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitRemoveSubscriber(imsi) {
		let param = `StartQueue&action=RemoveSubscriber&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitModifySubscriber(imsi, action, value) {
		let param = `ModifySubscriber&imsi=${imsi}&action=${action}&value=${value}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	/* POLLING */
	getPollQueue(id) {
		let param = `IOT_PollQueue&id=${id}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getPollUntilDone: async (id, timeout, interval, callback) => {
		if (typeof id === "undefined" || id < 1) return "No ID";
		let endTime = Number(new Date()) + (timeout || 2000);
		interval = interval || 1000;
		let checkCondition = function (resolve, reject) {
			provisioningService
				.getPollQueue(id)
				.then(result => {
					//console.log('poll status:'+result.status.toString())
					//console.log("poll result:",result)
					callback(result);
					if (result.status.toString().includes("DONE")) {
						resolve(result);
					} else if (result.status.toString().includes("ERROR")) {
						reject(result);
					} else if (Number(new Date()) < endTime) {
						setTimeout(checkCondition, interval, resolve, reject);
					} else {
						reject("timed out for queueid:" + id + " - " + arguments);
					}
				})
				.catch(err => {
					console.error('polling error:',err)
				});
		};
		return new Promise(checkCondition);
	},

	/* hss */
	changeHssProfile(imsi, roaming, hssProfile) {
		let param = `ChangeHssProfile&imsi=${imsi}&profile_name=${hssProfile}&geography=${roaming}&staticlp=`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	registerHss(imsi, hssProfile) {
		let param = `RegisterHss&imsi=${imsi}&staticlp=&lteTemplate=${hssProfile}&reset=1&lte=1`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	/* data plans */
	submitAddDataPlan(msisdn, imsi, dataplan) {
		let param = `IOT_AddSubscsriberDataPlan&msisdn=${msisdn}&imsi=${imsi}&dataPlan=${dataplan}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	deleteDataBucket(dataGroup) {
		let param = `IOT_DeleteDataBucket&dataGroup=${dataGroup}&customerGroup='Administrator'`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getMsisdnList() {
		let params = `IOT_GetMsisdnList`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSimpleActivate({imsi, msisdn, product}) {
		const params = `IOT_Activate&imsi=${imsi}&msisdn=${msisdn}&product=${product}`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSimpleTerminate(imsi) {
		const params = `IOT_Terminate&imsi=${imsi}&return_stock=KeepProperties`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSimpleSuspend(imsi) {
		const params = `IOT_Suspend&imsi=${imsi}`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSimpleResume(imsi) {
		const params = `IOT_Resume&imsi=${imsi}`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

};

export default provisioningService;
